import { ServiceCard } from '@/components/ServiceCard';

const services = [
  {
    icon: (
      <svg className="w-7 h-7 text-gold-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
      </svg>
    ),
    title: 'Eficiência Tributária',
    description: 'Planejamento tributário para otimizar os impostos sobre imóveis e rendimentos.',
    features: [
      'Regularização de rendimentos de alugueis',
      'Revisão de tributos',
      'Aproveitamento de créditos e incentivos fiscais',
      'Relatórios de impacto na lucratividade',
    ],
  },
  {
    icon: (
      <svg className="w-7 h-7 text-gold-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" />
      </svg>
    ),
    title: 'Segurança Patrimonial',
    description: 'Preserve seu patrimônio e garanta a tranquilidade para as próximas gerações.',
    features: [
      'Levantamento de pendências fiscais',
      'Organização de obrigações acessórias',
      'Contratos e estruturas auditáveis',
      'Governança contábil contínua',
    ],
  },
  {
    icon: (
      <svg className="w-7 h-7 text-gold-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z" />
      </svg>
    ),
    title: 'Governança Transparente',
    description: 'Garanta transparência e controle sobre a gestão do seu patrimônio.',
    features: [
      'Relatórios detalhados de rendimentos e impostos',
      'Controle de custos e despesas',
      'Estruturação auditável e fiscalmente adequada',
      'Relatórios de impacto na lucratividade',
    ],
  },
];

export function Services() {
  return (
    <section id="servicos" className="py-20 lg:py-28 bg-neutral-50">
      <div className="container mx-auto px-4 lg:px-8">
        {/* Section Header */}
        <div className="text-center max-w-3xl mx-auto mb-16">
          <span className="text-gold-600 font-semibold text-sm uppercase tracking-wider">Somos especialistas</span>
          <h2 className="text-3xl sm:text-4xl font-bold text-navy-900 mt-3 mb-4">
            Com a estrutura correta, seu aluguel rende mais, todo mês.
          </h2>
          <p className="text-lg text-neutral-600">
            Uma economia mensal acumulada no longo prazo pode fazer toda a diferença.
          </p>
        </div>

        {/* Services Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {services.map((service, index) => (
            <ServiceCard
              key={index}
              icon={service.icon}
              title={service.title}
              description={service.description}
              features={service.features}
            />
          ))}
        </div>
      </div>
    </section>
  );
}
